import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=564dc6d9&scoped=true&"
import script from "./FormCard.vue?vue&type=script&lang=js&"
export * from "./FormCard.vue?vue&type=script&lang=js&"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=564dc6d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564dc6d9",
  null
  
)

export default component.exports